import React from 'react';
import SimpleAdminDashboard from './SimpleAdminDashboard';

const AdminDashboard = () => {
  return <SimpleAdminDashboard />;
};

export default AdminDashboard;
